module.exports = __webpack_public_path__ + "img/austine-team.28978804.svg";